import type { PermissionRequirement } from '~/utils/rbac'
import type { PermissionTuple } from '~/utils/ability'

/** Lire l'écran : les mêmes droits que la route `GET /inventories/overview` (l'un OU l'autre). */
export const INVENTORIES_READ: PermissionRequirement = {
  any: [
    ['read', 'stores.all-inventories.history'],
    ['read', 'stores.current-inventory.inventory'],
  ],
}

/** Valider ou refuser un lot défectueux retenu : une seule action spéciale (kanban #823). */
export const DEFECTIVE_BATCH_VALIDATE: PermissionTuple = [
  'validate-defective-batch',
  'stores.defective-batches.validation',
]

// ─── Modale boutique (spec v2 §4.3) : une action, un tuple, comme les routes qu'elles appellent ──

/** Terminer / rouvrir, saisir les non scannables : `POST /inventories/:id/finished-status`. */
export const INVENTORY_FINISH: PermissionTuple = ['edit', 'stores.current-inventory.inventory']

/** Valider : `POST /inventories/:id/status` `validated`. */
export const INVENTORY_VALIDATE: PermissionTuple = [
  'validate-inventory',
  'stores.current-inventory.validation',
]

/** Annuler : `POST /inventories/:id/status` `canceled` — revient à supprimer l'inventaire en cours. */
export const INVENTORY_CANCEL: PermissionTuple = ['delete', 'stores.current-inventory.inventory']

/** Le commentaire s'édite depuis l'inventaire en cours comme depuis l'historique : OU. */
export const INVENTORY_DESCRIPTION: PermissionRequirement = {
  any: [
    ['edit', 'stores.current-inventory.inventory'],
    ['edit', 'stores.all-inventories.history'],
  ],
}
